const productRecommendationsLayoutPageMapping = {
  HORIZONTAL: [ "product", "customers/order", "cart" ], // horizontal slider / default
  VERTICAL: [ "checkout" ] // vertical with "Tambah" (add to cart) button
}

const priceToRupiah = (price) => {
  const actualPrice = price / 100;
  return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(actualPrice);
}

const createVerticalRecommendationListItem = (listItemToRender) => {
  const isPreorder = listItemToRender.dataset.isPreorder === 'true';
  const productId = listItemToRender.dataset.productId;
  const variantId = listItemToRender.dataset.firstAvailableVariantId;
  const productTitle = listItemToRender.dataset.productTitle;
  const variantTitle = listItemToRender.dataset.firstAvailableVariantTitle;
  const variantPrice = listItemToRender.dataset.firstAvailableVariantPrice;
  const imageSrc = listItemToRender.dataset.imageSrc;
  const preorderPropertyTag = isPreorder ? listItemToRender.dataset.preorderProductTag: "";
  const defaultVariantNotAvailable = listItemToRender.dataset.defaultVariantNotAvailable === "true";

  const verticalListItem = `
    <tr
      class="product"
      data-product-id="${productId}"
      data-product-title="${productTitle}"
      data-first-available-variant-id="${variantId}"
      data-first-available-variant-price="${variantPrice}"
      ${variantTitle ? 'data-first-available-variant-title="' + variantTitle + '"' : ''}
      data-is-preorder="${isPreorder}"
      ${isPreorder ? 'data-preorder-product-tag="' + listItemToRender.dataset.preorderProductTag + '"' : ''}
      ${defaultVariantNotAvailable ? 'data-default-variant-not-available="true"' : ''}
      data-image-src="${imageSrc}"
      ${defaultVariantNotAvailable ? 'data-default-variant-not-available="true"' : ''}
    >
      <td class="product__image">
        <div class="product-thumbnail">
          <div class="product-thumbnail__wrapper">
            <img src="${imageSrc}" class="product-thumbnail__image">
          </div>
        </div>
      </td>
      <th class="product__description">
        <span class="product__description__name order-summary__emphasis">${productTitle}</span>
        ${ variantTitle ? '<span class="product__description__variant order-summary__small-text">' + variantTitle + '</span>' : ''}
        <span class="order-summary__emphasis">${variantPrice}</span>
      </th>
      <td class="product__quantity"></td>
      <td class="product__action">
        <form action="/cart/add" method="post" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
          <input type="hidden" name="id" value="${variantId}">
          ${
            isPreorder
            ?
              '<input type="hidden" name="properties[_is_preorder]" value="Pre-order item">' +
              '<input type="hidden" name="properties[_preorder_tag]" value="' + preorderPropertyTag + '">' +
              '<input type="hidden" name="properties[_preorder_locale]" value="id">'
            : ''
          }
          <button type="button" id="co-rec-add-${variantId}">Tambah</button>
        </form>
      </td>
    </tr>
  `;
  return verticalListItem;
}

const setAddToCartEventListener = (variantId) => {
  document.body.addEventListener("click", event => {
    if (event.target === document.getElementById(`co-rec-add-${variantId}`)) {
      document.querySelectorAll('.product__action button').forEach(button => {
        button.disabled = true;
      });
      const form = event.target.closest('form');
      const formData = new FormData(form);
      
      fetch('/cart/add.js', { 
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
        body: formData
      })
        .then(response => response.json())
        .then(() => {
          // add item to cart local storage
          const variantId = formData.get('id');
          let cartItemsState = CartStateLocalStorageUtil.getAll();
          const currentItemIndex = cartItemsState.findIndex(item => item.variantId == variantId);
          if (currentItemIndex >= 0) {
            cartItemsState[currentItemIndex].checkboxStatus = true;
            CartStateLocalStorageUtil.update(cartItemsState);
          }
          document.location.reload();
        });
    }
  });
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.dataset.url) {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          let isVariantReplacementNeeded = false;
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {

            // check to handle OOS preorder product
            const listItems = recommendations.querySelectorAll('ul[id^="Slider-Product-"] > li');
            listItems.forEach(listItem => {
              const isPreorder = listItem.dataset.isPreorder === 'true';
              const listItemProductId = listItem.dataset.productId;
              const variantId = listItem.dataset.firstAvailableVariantId;
              const inventoryQty = parseInt(listItem.dataset.inventoryQty);

              if (isPreorder) {
                const preorderSettings = getPreorderSettingsBackup();

                // if preorder item is OOS, mark and replace it with available variant
                const hasDifferentPreorderSettingsPerVariant = !!variantId && !!preorderSettings.products[listItemProductId][variantId]
                const preorderItemSetting = hasDifferentPreorderSettingsPerVariant 
                ? preorderSettings.products[listItemProductId][variantId]
                : preorderSettings.products[listItemProductId];
                if (preorderItemSetting.end_condition) {
                  const globoLimit = JSON.parse(preorderItemSetting.end_condition)
                    .find(condition => condition.type === 'quantity')
                    .condition;
                  const max = Math.abs(globoLimit - inventoryQty);
                  if (max <= 0) {
                    listItem.dataset.defaultVariantNotAvailable = true;
                    isVariantReplacementNeeded = true;
                  };
                }
              }
            });
            this.innerHTML = recommendations.innerHTML;
          }

          const onRecommendationsRendered = () => {
            if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
              this.remove();
            }
  
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
  
            this.initSlider();
            
            document.querySelectorAll('.grid__item.slider__slide.product-grid-item script').forEach(script => {
              eval(script.innerHTML);
            });
          }
          
          if (isVariantReplacementNeeded) {
            const readyToReplaceVariantEvent = new CustomEvent('theme.recommendations.ready-to-replace-variant');
            readyToReplaceVariantEvent.callback = () => {
              onRecommendationsRendered();
              setTimeout(() => {
                this.moveToItemIndex(0);
              }, 200);
            };
            document.dispatchEvent(readyToReplaceVariantEvent);
          } else {
            onRecommendationsRendered();
          }
          
        })
        .catch(e => {
          console.error(e);
        });
    } else if (this.dataset.urls) {

      const pageName = this.dataset.pageName;
      if (productRecommendationsLayoutPageMapping.VERTICAL.includes(pageName)) {
        this.initVerticalRecommendationsContainer();
        this.initSkeletonLoaders();
      }

      const recommendationUrls = this.dataset.urls.split(',');
      const productHandles = this.dataset.productHandles.split(',');
      if (recommendationUrls.length < 1) {
        if (productRecommendationsLayoutPageMapping.VERTICAL.includes(pageName)) {
          SkeletonLoaders.stop("vertical-checkout-recommendations");
          this.removeVerticalRecommendationContainer();
        }
        return;
      };
      const apiCalls = [];
      this.recommendationProductIds = [];

      // get recommendations section id that's shown on PDP
      // use section rendering API
      this.getPdpRecommendationSectionIdByHandle(productHandles[0])
        .then(sectionId => {
          recommendationUrls.forEach(recommendationUrl => {
            const urlObject = new URL(window.location.origin + recommendationUrl);
            // replace the section id with the section id from PDP
            urlObject.searchParams.set("section_id", sectionId);
            apiCalls.push(fetch(urlObject.toString()));
            
            // popuplate product ids, needed for handling overlapping products later
            this.recommendationProductIds.push(urlObject.searchParams.get("product_id"));
          });

          Promise.all(apiCalls)
            .then(responses => Promise.all(responses.map(response => response.text())))
            .then(texts => {
              this.initMultipleRecommendations(texts);
            });
        });
    }
  }

  getPdpRecommendationSectionIdByHandle(productHandle) {
    const SHOPIFY_SECTION_PREFIX = "shopify-section-";
    const RECOMMENDATIONS_SECTION_NAME = "product-recommendations-custom";
    return new Promise((resolve, reject) => {
      fetch(window.location.origin + "/products/" + productHandle)
        .then(response => response.text())
        .then(text => {
          const pdpHtml = new DOMParser()
            .parseFromString(text, 'text/html');
          const productRecommendationsSection = pdpHtml.querySelector(`[id$=${RECOMMENDATIONS_SECTION_NAME}]`);
          const sectionId = productRecommendationsSection.id.slice(SHOPIFY_SECTION_PREFIX.length);
          resolve(sectionId);
        })
        .catch(error => {
          reject(error);
        })
    })
  }

  initVerticalRecommendationsContainer() {
    // for vertical style recommendation section, the structure will be different with section's code, including the container
    const verticalRecommendationsContainer = document.createElement('div');
    verticalRecommendationsContainer.classList.add('order-summary__section', 'vertical-rec-container');
    verticalRecommendationsContainer.innerHTML = `
      <h2 class="product-recommendations__heading"></h2>
      <div class="order-summary__section__content">
        <table class="product-table product-recommendations-custom">
          <tbody id="recommendations-table-body"></tbody>
        </table>
      </div>
    `;
    const productList = document.querySelector(".order-summary__sections .order-summary__section--product-list");
    productList.after(verticalRecommendationsContainer);
    this.style.padding = "0";
    this.closest('section').style.padding = "0";
  }

  removeVerticalRecommendationContainer() {
    const verticalRecommendationsContainer = document.querySelector('.vertical-rec-container');
    verticalRecommendationsContainer.parentElement.removeChild(verticalRecommendationsContainer);
  }

  initSkeletonLoaders() {
    const configs = [
      {
        key: "vertical-checkout-recommendations-heading",
        groupId: "vertical-checkout-recommendations",
        relatedSelector: ".vertical-rec-container .product-recommendations__heading",
        options: {
          width: SkeletonLoaders.WIDTHS.FORM_HEADING,
          height: SkeletonLoaders.HEIGHTS.FORM_HEADING,
          marginTop: true,
          marginBottom: true
        }
      },
      {
        key: "vertical-checkout-recommendations-content",
        groupId: "vertical-checkout-recommendations",
        relatedSelector: ".vertical-rec-container .order-summary__section__content",
        options: {
          height: SkeletonLoaders.HEIGHTS.SHORT,
          marginBottom: true
        }
      }
    ];

    configs.forEach(config => {
      SkeletonLoaders.insertToDom(config);
    });
    SkeletonLoaders.configs = [ ...SkeletonLoaders.configs, ...configs];
    SkeletonLoaders.start("vertical-checkout-recommendations");
  }

  onMultipleRecommendationsRendered(numberOfRenderedProducts) {
    // setup slider control (mobile) for horizontal style recommendation section
    const pageName = this.dataset.pageName;
    if (productRecommendationsLayoutPageMapping.HORIZONTAL.includes(pageName)) {
      if (numberOfRenderedProducts === 0) {
        const recommendationSection = this.closest('.section');
        if (recommendationSection) {
          recommendationSection.parentElement.removeChild(recommendationSection);
        }
        return;
      }
      const slideshowControlWrapper = this.querySelector('.slideshow__control-wrapper');
      const slideshowButtonClasses = slideshowControlWrapper.querySelector('button').getAttribute('class');
      const slideshowButtonAriaControls = slideshowControlWrapper.querySelector('button').getAttribute('aria-controls');
      slideshowControlWrapper.innerHTML = "";
      for (let i = 1; i <= Math.ceil(numberOfRenderedProducts / 2); i++) {
        slideshowControlWrapper.innerHTML += `
          <button
            class="${slideshowButtonClasses}"
            aria-controls="${slideshowButtonAriaControls}"
            tabIndex="${i}"
          >
            <span class="dot">
          </button>
        `
      }

      if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
        this.remove();
      }

      if (this.querySelector('.grid__item')) {
        this.classList.add('product-recommendations--loaded');
      }

      this.initSlider();
    } else {
      const prevButton = document.querySelector('product-recommendations .slider-desktop-custom__prev-button');
      if (prevButton) prevButton.parentElement.removeChild(prevButton);
      const nextButton = document.querySelector('product-recommendations .slider-desktop-custom__next-button');
      if (nextButton) nextButton.parentElement.removeChild(nextButton);
      const sliderButtons = document.querySelector('product-recommendations .slider-buttons');
      if (sliderButtons) sliderButtons.parentElement.removeChild(sliderButtons);

      SkeletonLoaders.stop("vertical-checkout-recommendations");

      if (numberOfRenderedProducts === 0) {
        this.removeVerticalRecommendationContainer();
        return;
      }
    }

    this.classList.remove('visually-hidden');

    document.querySelectorAll('.grid__item.slider__slide.product-grid-item script').forEach(script => {
      eval(script.innerHTML);
    });
  }

  initMultipleRecommendations(texts) {
    let isVariantReplacementNeeded = false;
    this.classList.add('visually-hidden');
    const pageName = this.dataset.pageName;
    // setup container element
    for (let i = 0; i < texts.length; i++) {
      const html = document.createElement('div');
      html.innerHTML = texts[i];
      const recommendations = html.querySelector('product-recommendations');
      if (recommendations && recommendations.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML;
        break;
      }
    }

    // setup list item content
    const listContainer = this.querySelector('ul[id^="Slider-Product-"]');
    if (!listContainer) {
      this.onMultipleRecommendationsRendered(0);
      return;
    };

    listContainer.innerHTML = "";

    if (productRecommendationsLayoutPageMapping.VERTICAL.includes(pageName)) {
      const recommendationHeading = this.querySelector('.product-recommendations__heading');
      const recommendationHeadingText = recommendationHeading.textContent;
      document.querySelector('.vertical-rec-container .product-recommendations__heading').textContent = recommendationHeadingText;
      recommendationHeading.parentElement.removeChild(recommendationHeading);
    }

    const productPaths = [];

    if (productPaths.length < this.dataset.maxItems) {
      for (let i = 0; i < texts.length; i++) {
        const html = document.createElement('div');
        html.innerHTML = texts[i];
        const listItems = html.querySelectorAll('ul[id^="Slider-Product-"] > li');
  
        if (listItems.length < 1) {
          continue;
        }
        
        listItems.forEach(listItem => {
          const productLink = listItem.querySelector('.card > .card__content a');
          const productUrl = new URL(productLink.href);
          
          const isPreorder = listItem.dataset.isPreorder === 'true';
          const listItemProductId = listItem.dataset.productId;
          const variantId = listItem.dataset.firstAvailableVariantId;
          const inventoryQty = parseInt(listItem.dataset.inventoryQty);
  
          if (isPreorder) {
            const preorderSettings = getPreorderSettingsBackup();
  
            // if preorder item is OOS, mark to hide and replace it with available variant
            // if available then continue to render
            const hasDifferentPreorderSettingsPerVariant = !!variantId && !!preorderSettings.products[listItemProductId][variantId];
            const preorderItemSetting = hasDifferentPreorderSettingsPerVariant  
              ? preorderSettings.products[listItemProductId][variantId]
              : preorderSettings.products[listItemProductId];
            if (preorderItemSetting.end_condition) {
              const globoLimit = JSON.parse(preorderItemSetting.end_condition)
                .find(condition => condition.type === 'quantity')
                .condition;
              const max = Math.abs(globoLimit - inventoryQty);
              if (max <= 0) {
                listItem.dataset.defaultVariantNotAvailable = true;
                isVariantReplacementNeeded = true;
              };
            }
          }
          
          // render recommendation item
          const productPath = productUrl.origin + productUrl.pathname;
          if (productPaths.length < this.dataset.maxItems && !productPaths.includes(productPath) && !this.recommendationProductIds.includes(listItemProductId)) {
            productPaths.push(productPath);
            if (productRecommendationsLayoutPageMapping.HORIZONTAL.includes(pageName)) {
              // for horizontal style, we can copy the list item from the section that we got
              listContainer.innerHTML += listItem.outerHTML;
  
            } else if (productRecommendationsLayoutPageMapping.VERTICAL.includes(pageName)) {
              // for vertical style, we need to construct a new structure because it's different with the section's code
              const recommendationsTableBody = document.getElementById('recommendations-table-body');
              recommendationsTableBody.innerHTML += createVerticalRecommendationListItem(listItem);
              setAddToCartEventListener(variantId);
            }
          }
        });
      }
    }

    if (isVariantReplacementNeeded) {
      const readyToReplaceVariantEvent = new CustomEvent('theme.recommendations.ready-to-replace-variant');
      readyToReplaceVariantEvent.callback = () => {
        this.onMultipleRecommendationsRendered(productPaths.length);
      }
      document.dispatchEvent(readyToReplaceVariantEvent);
    } else {
      this.onMultipleRecommendationsRendered(productPaths.length);
    }
  }
  
  initSlider() {
    this.slider = this.querySelector('[id^="Slider-Product"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-Product"]');
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.sliderCustomPrevButton = this.querySelector('.slider-desktop-custom__prev-button');
    this.sliderCustomNextButton = this.querySelector('.slider-desktop-custom__next-button');

    if (!this.slider) {
      // empty recommendations, remove the whole section
      this.closest('.shopify-section').remove();
      return;
    }

    this.initPages();
    
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);
    
    this.slider.addEventListener('scroll', this.update.bind(this));
    
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.sliderControlButtons.forEach(dot => {
      dot.addEventListener('click', () => this.moveActiveThumbnail(dot))
    })
    
    this.sliderCustomPrevButton.addEventListener('click', event => {
      event.stopPropagation();
      const previousPage = this.currentPage;
      const targetPage = this.currentPage - 1;
      const itemIndex = (targetPage - 1) * this.slidesPerPage;
      this.moveToItemIndex(itemIndex);

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }}));
      }
    });

    this.sliderCustomNextButton.addEventListener('click', event => {
      event.stopPropagation();
      const previousPage = this.currentPage;
      const targetPage = this.currentPage + 1;
      const itemIndex = (targetPage - 1) * this.slidesPerPage;
      this.moveToItemIndex(itemIndex);

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }}));
      }
    });
  }

  moveToItemIndex(index) {
    this.sliderItems = this.querySelectorAll('[id^="Slide-Product"]');
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

    const sliderPosition = this.sliderItems[0].offsetWidth * index;
    this.slider.scrollTo({
      left: sliderPosition
    });
    
    this.updateSliderControlButtons();

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
  }

  moveActiveThumbnail(dot) {
    const tabIndex = dot.getAttribute('tabIndex');
    
    const previousPage = this.currentPage;
    this.currentPage = tabIndex;
    const itemIndex = (tabIndex - 1) * this.slidesPerPage;
    this.moveToItemIndex(itemIndex);

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }
  }
  
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    
    if (this.sliderItemsToShow.length < 2) return;

    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.round((this.slider.clientWidth) / this.sliderItemOffset);

    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / (this.sliderItemOffset * this.slidesPerPage)) + 1;
    this.updateSliderControlButtons();
    
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;
  }

  updateSliderControlButtons() {
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    if (!this.sliderControlButtons.length) return;

    const sliderPages = Math.ceil(this.sliderItemsToShow.length / 2);
    if (this.currentPage > sliderPages) return;
    
    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    if (this.currentPage >= 0) {
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }

    if (window.matchMedia('(min-width: 990px)').matches && this.sliderItemsToShow.length > 5) {
      this.slider.classList.add('slider-desktop-custom--buttons-visible');
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.sliderCustomPrevButton.setAttribute('disabled', 'disabled');
        this.sliderCustomPrevButton.style.display = 'none';
      } else {
        this.sliderCustomPrevButton.removeAttribute('disabled');
        this.sliderCustomPrevButton.style.display = 'block';
      }

      if (Math.abs(this.slider.clientWidth + this.slider.scrollLeft - this.slider.scrollWidth) < 30) {
        this.sliderCustomNextButton.setAttribute('disabled', 'disabled');
        this.sliderCustomNextButton.style.display = 'none';
      } else {
        this.sliderCustomNextButton.removeAttribute('disabled');
        this.sliderCustomNextButton.style.display = 'block';
      }
    } else {
      this.slider.classList.remove('slider-desktop-custom--buttons-visible');
      this.sliderCustomPrevButton.setAttribute('disabled', 'disabled');
      this.sliderCustomPrevButton.style.display = 'none';
      this.sliderCustomNextButton.setAttribute('disabled', 'disabled');
      this.sliderCustomNextButton.style.display = 'none';
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class ProductRecommendationsV2 extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.productId = this.dataset.productId;
    this.maxItems = this.dataset.maxItems || 5;

    if (!this.sectionId || !this.productId) {
      return;
    }
    this.fetchRecommendations();
  }

  async fetchRecommendations() {
    const fetchUrl = `/recommendations/products?section_id=${this.sectionId}&product_id=${this.productId}&limit=${this.maxItems}`;
    try {
      const response = await fetch(fetchUrl);
      if (!response.ok) throw new Error(`Failed to fetch recommendations. Status: ${response.status}`);

      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");

      const recommendationsContainer = doc.querySelector(".product-recommendations-list__inner");
      const carouselControls = document.querySelector(".product-recommendations-v2-carousel-controls");
      if (!recommendationsContainer || recommendationsContainer.children.length === 0) {
        return;
      }

      this.innerHTML = "";
      this.appendChild(recommendationsContainer);
      if (carouselControls) {
        carouselControls.style.display = "block";
        // Initialize carousel only for PDP Recommendations Section
        const cardsWrapper = document.querySelectorAll("#cards-wrapper");
        const controlsContainer = document.querySelectorAll(".carousel-controls");
        cardsWrapper.forEach((wrapper) => {
          const wrapperDataId = wrapper.getAttribute("data-id");
          const matchingControl = [...controlsContainer].find(
            (control) => control.getAttribute("data-id") === wrapperDataId
          );
          if (matchingControl) {
            initializeCarousel(wrapper, matchingControl);
          } else {
            console.warn(`No matching control found for wrapper with data-id: ${wrapperDataId}`);
          }
        });
      }
    } catch (error) {
      console.error("Error fetching recommendations:", error);
    }
  }
}

customElements.define("product-recommendations-v2", ProductRecommendationsV2);

function createVerticalRecommendationListItemFromVariantData(listItemToBeReplaced, variantData) {
  const listItem = listItemToBeReplaced;
  listItem.dataset.productId = variantData.productId;
  listItem.dataset.productTitle = variantData.productTitle;
  listItem.dataset.firstAvailableVariantId = variantData.variantId;
  listItem.dataset.firstAvailableVariantPrice = priceToRupiah(variantData.variantPrice);
  listItem.dataset.firstAvailableVariantTitle = variantData.variantTitle || "";
  listItem.dataset.isPreorder = variantData.isPreorder;
  listItem.dataset.preorderProductTag = variantData.preorderProductTag || "";
  listItem.dataset.imageSrc = variantData.imageSrc;
  return createVerticalRecommendationListItem(listItem);
}

function replaceHorizontalRecommendationListItemVariantData(listItemToBeReplaced, variantData) {
  listItemToBeReplaced.dataset.productId = variantData.productId;
  listItemToBeReplaced.dataset.productTitle = variantData.productTitle;
  listItemToBeReplaced.dataset.firstAvailableVariantId = variantData.variantId;
  listItemToBeReplaced.dataset.firstAvailableVariantPrice = priceToRupiah(variantData.variantPrice);
  listItemToBeReplaced.dataset.firstAvailableVariantTitle = variantData.variantTitle || "";
  listItemToBeReplaced.dataset.isPreorder = variantData.isPreorder;
  listItemToBeReplaced.dataset.preorderProductTag = variantData.preorderProductTag || "";
  listItemToBeReplaced.dataset.imageSrc = variantData.imageSrc;

  listItemToBeReplaced.querySelectorAll('.card__media img').forEach(img => {
    img.src = variantData.imageSrc;
    img.removeAttribute('srcset');
  });
  listItemToBeReplaced.querySelectorAll('.card__information a[href]').forEach(anchorElement => {
    anchorElement.href = variantData.variantUrl;
    anchorElement.textContent = variantData.productTitle;
  });
  
  const priceElement = listItemToBeReplaced.querySelector('.price[data-price]');
  priceElement.dataset.price = variantData.variantPrice;
  const regularPriceElement = priceElement.querySelector('.price__regular');
  const salePriceElement = priceElement.querySelector('.price__sale');
  const isOnSale = variantData.variantCompareAtPrice > variantData.variantPrice;
  if (isOnSale) {
    regularPriceElement.parentElement.removeChild(regularPriceElement);
    salePriceElement.querySelector('.price-item--sale').textContent = priceToRupiah(variantData.variantPrice);
    salePriceElement.querySelector('.price-item--regular').textContent = priceToRupiah(variantData.variantCompareAtPrice);
  } else {
    const onSaleBadge = listItemToBeReplaced.querySelector('.badge-on-sale');
    if (onSaleBadge) {
      onSaleBadge.parentElement.removeChild(onSaleBadge);
    }
    salePriceElement.parentElement.removeChild(salePriceElement);
    regularPriceElement.querySelector('.price-item--regular').textContent = priceToRupiah(variantData.variantPrice);
  }

  return listItemToBeReplaced;
}

function getAvailableVariant(productId) {
  return new Promise(resolve => {
    fetch(`/search?type=product&view=variantdatajson&q=id:${productId}`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
      }
    )
      .then(response => response.json())
      .then(products => {
        const product = products[0];
        const preorderProductTag = product.tags.find(tag => tag.includes('#PREORDER')) || null;
        const isPreorder = preorderProductTag !== null;
        let availableVariant = null;
        if (isPreorder) {
          availableVariant = product.variants.find(variant => {
            const preorderSettings = getPreorderSettingsBackup();
            const hasDifferentPreorderSettingsPerVariant = !!variant.id && !!preorderSettings.products[product.id][variant.id];
            const preorderItemSetting = hasDifferentPreorderSettingsPerVariant 
              ? preorderSettings.products[product.id][variant.id]
              : preorderSettings.products[product.id];
            if (preorderItemSetting.end_condition) {
              const globoLimit = JSON.parse(preorderItemSetting.end_condition)
                .find(condition => condition.type === 'quantity')
                .condition;
              const max = Math.abs(globoLimit - variant.inventory_quantity);
              return max > 0;
            }
            return false;
          }) || null;
        } else {
          availableVariant = product.variants.find(variant => variant.available) || null;
        }

        if (availableVariant) {
          resolve({
            productId: product.id,
            productTitle: product.title,
            variantId: availableVariant.id,
            variantPrice: availableVariant.price,
            variantCompareAtPrice: availableVariant.compare_at_price,
            variantTitle: availableVariant.title,
            variantUrl: availableVariant.url,
            isPreorder: isPreorder,
            preorderProductTag: preorderProductTag,
            imageSrc: availableVariant.image.src
          });
        } else {
          resolve(null);
        }
      })
  });
}

document.addEventListener('theme.recommendations.ready-to-replace-variant', (event) => {
  const recommendedItemsToBeReplaced = document.querySelectorAll('.product-recommendations-custom [data-default-variant-not-available]');
  const numberOfItems = recommendedItemsToBeReplaced.length;
  if (numberOfItems > 0) {
    const variantChecks = [];
    recommendedItemsToBeReplaced.forEach(listItem => {
      variantChecks.push(getAvailableVariant(listItem.dataset.productId));
    });
    Promise.all(variantChecks)
      .then(replacementVariants => {
        for (let i = 0; i < numberOfItems; i++) {
          const listItem =  recommendedItemsToBeReplaced[i];
          const isVerticalLayout = listItem.tagName === "TR";
          const replacementVariantData = replacementVariants[i];
          if (replacementVariantData) {
            if (isVerticalLayout) {
              listItem.outerHTML = createVerticalRecommendationListItemFromVariantData(listItem, replacementVariantData);
              setAddToCartEventListener(replacementVariantData.variantId);
            } else {
              replaceHorizontalRecommendationListItemVariantData(listItem, replacementVariantData);
            }
            const changedListItem = document.querySelector(`.product-recommendations-custom [data-first-available-variant-id="${replacementVariantData.variantId}"]`);
            changedListItem.removeAttribute('data-default-variant-not-available');
          } else {
            listItem.parentElement.removeChild(listItem);
          }
        }

        if (event.callback) {
          event.callback();
        }
      })
  } else {
    if (event.callback) {
      event.callback();
    }
  }
})